import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FooterListComponent } from './footer-list/footer-list.component';
import { FooterCreateComponent } from './footer-create/footer-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: FooterListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: FooterCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'footer-create/:id',
        component: FooterCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FooterRoutingModule { }
